/**
 * 참고: https://stackoverflow.com/questions/56324813/how-to-detect-touch-device-in-2019
 */
export function getIsTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    // @ts-expect-error
    navigator.msMaxTouchPoints > 0
  );
}
